import React from "react";
import {
  getSmartTextColor,
  transformStringToColor,
} from "../../utilities/utilities";

export interface BadgeProps {
  bgColor?: string | null;
  text: string;
}

const Badge: React.FC<BadgeProps> = ({ bgColor, text }) => {
  const backgroundColor = bgColor ?? transformStringToColor(text);
  return (
    <div
      style={{
        backgroundColor: backgroundColor,
        color: getSmartTextColor(backgroundColor, 10, "#fff"),
      }}
      className="gen-badge"
    >
      {text}
    </div>
  );
};

export default Badge;
